module.exports = __webpack_public_path__ + "static/media/undraw_House_searching_re_stk8.3982cbea.png";